const CROSS_VALUES = [
  'no cover',
  'not covered',
  'not specified',
  'no offer',
  'no review',
  'not available',
];

const CHECK_VALUES = ['yes', 'included', 'free/included', 'covered'];

export const IsBenefitNoValue = ({
  value,
}: {
  value: string;
}) => {
  return (!value || R.includes(value.trim().toLowerCase(), CROSS_VALUES))
}

export const IsBenefitHasValue = ({
  value,
}: {
  value: string;
}) => {
  return (R.includes(value.trim().toLowerCase(), CHECK_VALUES))
}
